import React, { useState } from 'react';

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../../_metronic/_partials/controls";

// Validation schema
const CategoryEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Name is required"),

});
export function EditCategoryForm({
  category,
  btnRef,
  saveCategory,
}) {
  const [url, setUrl] = useState('')
  const fileSelected = async event => {
    document.getElementById('icon_1').click();
    document.getElementById('icon_1').onchange = async (e) => {
      let formData = new FormData();
      formData.append("uploadedFiles", e.target.files[0]);
      var AWS = require('aws-sdk');
      var files = document.getElementById("icon_1").files;
      if (!files.length) {
        return alert("Please choose a file to upload first.");
      }
      AWS.config.update({
        secretAccessKey: "F2lrCapI3JjgKo2y7WPNiAXGiaMKrnFeawW/A4sr",
        accessKeyId: "AKIAX5356FAXLFSZVSMR",
        region: "ap-southeast-1"
      });
      var file = files[0];
      var extension = file.type.split("/")[1];

      var key = Math.floor(new Date().getTime() / 1000) + extension;

      var albumBucketName = process.env.REACT_APP_MEDIA_BUCKET || "mylinkforall-media";
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: albumBucketName,
          Key: key,
          Body: file
        }
      });

      var promise = upload.promise();

      promise.then(
        function (data) {
          setUrl(data.Location)
          document.getElementById('image').style.display = "block"
          document.getElementById('image').src = data.Location
        },
        function (err) {
          return err;
        }
      );
    }
  }
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={category}
        validationSchema={CategoryEditSchema}
        onSubmit={(values) => {
          values.icon = url
          saveCategory(values);
        }}
      >
        {({ handleSubmit }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group row">
                <div className="col-lg-4">
                  <Field
                    name="name"
                    component={Input}
                    placeholder="name"
                    label="Name"
                  />
                </div>
                <div className="col-lg-4">
                  <Field
                    id="icon_1"
                    hidden
                    name="icon_1"
                    type="file"
                    component={Input}
                    accept="image/*"
                  />
                  <label>Update Icon</label>

                  <button className="form-control btn btn-secondary" onClick={event => fileSelected(event)} >Upload Icon</button>
                </div>


                <div className="col-lg-4">
                  <img src={category.icon} alt="image_icon" id="image" style={{ width: "60px", padding: "0.5rem 0.1rem" }} />
                </div>
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
/**
 *
 * <a onClick={event => fileSelected(event)} style={{display: "block",padding:"0.5rem",width: "inherit",border: "1px solid #cec9c9"}}>Upload Icon</a>
 *
 */